import { Controller } from "@hotwired/stimulus"

// Recherche dans l'Annuaire des entreprises pendant la frappe (frame people_quick_company_results).
export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String }

  connect() {
    if (this.inputTarget.value.trim().length >= 2) this.load()
  }

  disconnect() { clearTimeout(this.timer) }

  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), 350)
  }

  load() {
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      return
    }
    this.resultsTarget.src = `${this.urlValue}?${new URLSearchParams({ q: query })}`
  }
}
